module.exports = __webpack_public_path__ + "img/italy-leukaemia-male.cd6bc5de.png";